import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { useSearchService } from "../useAdminServices";
import { GlobalSearchResultDto } from "../../services/admin/types/search.types";
import { queryKeys } from "../../lib/react-query/queryClient";

export const useGlobalSearchQuery = (
  query: string,
  options?: { enabled?: boolean },
): UseQueryResult<GlobalSearchResultDto> => {
  const searchService = useSearchService();

  return useQuery({
    queryKey: queryKeys.searchResults(query),
    queryFn: async () => {
      if (!searchService) throw new Error("Search service not initialized");

      const result = await searchService.search(query);
      if (!result.success) {
        throw new Error(result.error?.message || "Search failed");
      }

      return result.data;
    },
    enabled: !!searchService && (options?.enabled ?? true),
    staleTime: 30 * 1000, // 30 seconds
    gcTime: 5 * 60 * 1000, // 5 minutes
  });
};
